import { createSelector } from 'reselect';
import { currentPPOSelector } from '../App/selectors';

export const activePPOThemeSelector = createSelector(
  currentPPOSelector,
  ppo => ppo.theme || {},
);
